// extracted by css-extract-rspack-plugin
export default {"banner":"WelcomeBanner-module__banner__uYs9r"};